import { useNavigate } from "@tanstack/react-router";
import type { AnalyticsFilters } from "./-types";

export function useFilterUpdates() {
  const navigate = useNavigate();

  const updateFilter = <K extends keyof AnalyticsFilters>(key: K, value: AnalyticsFilters[K]) => {
    navigate({
      to: "/admin/analytics",
      search: (prev) => ({
        ...(prev as AnalyticsFilters),
        [key]: value,
      }),
    });
  };

  const updateMultipleFilters = (updates: Partial<AnalyticsFilters>) => {
    navigate({
      to: "/admin/analytics",
      search: (prev) => ({
        ...(prev as AnalyticsFilters),
        ...updates,
      }),
    });
  };

  const resetFilters = () => {
    navigate({
      to: "/admin/analytics",
      search: {
        tab: "students", // Default to Student Dashboard
      } as AnalyticsFilters,
    });
  };

  return {
    updateFilter,
    updateMultipleFilters,
    resetFilters,
  };
}
